import { graphql } from "@/graphql/generated";

export const addAnnualMunicipalPropertyConsumptionMutationDocument = graphql(/* GraphQL */ `
  mutation AddAnnualMunicipalPropertyConsumption($input: AddAnnualMunicipalPropertyConsumptionInput!) {
    addAnnualMunicipalPropertyConsumption(input: $input) { id }
  }
`);
